export default "__VITE_ASSET__DbcD7Uu0__"